import { ReactNode } from 'react';
import { Space, Typography } from 'antd';
import { BulbOutlined, InfoCircleOutlined, QuestionCircleOutlined } from '@ant-design/icons';
import SectionTitle, { sectionIconStyle } from './SectionTitle';

export type DetailsProps = {
    whatHappened: ReactNode;
    whyItHappened?: ReactNode;
    requestedInformation?: ReactNode;
    nextSteps: ReactNode;
};

const Details = ({ whatHappened, whyItHappened, requestedInformation, nextSteps }: DetailsProps) => (
    <Space direction="vertical" size={16} style={{ width: '100%' }}>
        <div>
            <SectionTitle text="What happened?" icon={<QuestionCircleOutlined style={sectionIconStyle} />} />
            <Typography>{whatHappened}</Typography>
        </div>
        {whyItHappened && (
            <div>
                <SectionTitle text="Why it happened?" icon={<InfoCircleOutlined style={sectionIconStyle} />} />
                <Typography>{whyItHappened}</Typography>
            </div>
        )}
        {requestedInformation && (
            <div>
                <SectionTitle text="Requested Information" icon={<InfoCircleOutlined style={sectionIconStyle} />} />
                <Typography>{requestedInformation}</Typography>
            </div>
        )}
        <div>
            <SectionTitle text="Next Steps" icon={<BulbOutlined style={sectionIconStyle} />} />
            <Typography>{nextSteps}</Typography>
        </div>
    </Space>
);

export default Details;
